import { connectStreamSource, disconnectStreamSource } from "@hotwired/turbo"
import consumer from "./consumer"

class TurboCableStreamSourceElement extends HTMLElement {
  async connectedCallback() {
    connectStreamSource(this)
    this.subscription = consumer.subscriptions.create(
      {
        channel: "Turbo::StreamsChannel",
        signed_stream_name: this.getAttribute("signed-stream-name")
      },
      { received: (data) => this.dispatchEvent(new MessageEvent("message", { data })) }
    )
  }

  disconnectedCallback() {
    disconnectStreamSource(this)
    this.subscription?.unsubscribe()
  }
}

customElements.define("turbo-cable-stream-source", TurboCableStreamSourceElement)
